import { useCurrentUserContext } from 'contexts/currentUser';

export const useIsLoggedIn = () => {
  const { currentUser } = useCurrentUserContext();
  return !!currentUser;
};
